<template>
  <div style="position: relative; height: 100%">
    <div v-if="loading" class="progress-bar">
      <div class="progress-bar-value"></div>
    </div>
    <div
      style="z-index: 10"
      class="loading-overlay w-100 "
      v-if="ngoInfo && ngoInfo.current_stage == 4"
      
    >
    </div>
      <div
        style="z-index: 10"
        class="loading-overlay w-100"
        v-else-if="ngoInfo && ngoInfo.current_stage == 1"
        
      >
      <h3
        style="z-index: 11; position: absolute; top: 40%; right: 25%"
        class="absolute-center"
      >
        يمكنك الولوج لهذه الصفحة بعد إدخال معلومات الأعضاء المؤسسين
      </h3>
    </div>
  
      
    <div
      style="z-index: 10"
      class="loading-overlay"
      v-else-if="ngoInfo==null"
    >
      <h3
        style="z-index: 11; position: absolute; top: 40%; right: 21%"
        class=""
      >
      يمكنك الولوج لهذه الصفحة بعد إدخال معلومات المنظمة و معلومات الأعضاء المؤسسين
      </h3>
      
    </div>
    <div>

      <h3 class="brand-text mb-2">وثائق التأسيس</h3>
      <hr />
      <div>
        
        <div class="w-100" v-if="documents">
          <b-row>
            <b-col
              v-for="doc in documents.required.filter((el) => el.count === 1)"
              :key="doc.filename"
              cols="6"
              v-if="doc.filename !== 'نشرات استعلام الأعضاء المؤسسين'" 
            >
              <b-row class="align-items-center">
                <b-col cols="12">
                  <b-form-group :label="doc.is_required ? `${doc.filename}*` : `${doc.filename}`" label-for="file">
                    <b-input-group class="rounded">
                      <b-form-file
                        :state="getFileStatus(doc.id)"
                        :disabled="getFileStatus(doc.id) || isPending(doc.id)"
                        accept=".pdf"
                        @input="fileInput({ e: $event, attachment_id: doc.id })"
                        :placeholder="getFilePlaceholder(doc.id)"
                        browse-text="تصفح"
                        :multiple="doc.count > 1 ? true : false"
                      ></b-form-file>
                      <b-input-group-append>
                        <b-button-group class="mx-50">
                          <b-button
                            :disabled="
                              !documents.uploaded.find(
                                (el) => el.attachment.id === doc.id
                              )
                            "
                            variant="flat-info"
                            v-b-toggle.doc-view
                            class="btn-icon"
                            v-b-tooltip.hover.v-info.bottom
                            title="عرض الملف المرفوع"
                            @click="$router.push({
                                name: 'file-view',
                                query: {
                                  ep: setViewDoc(doc)
                                }
                              })"
                            ><feather-icon icon="EyeIcon"
                          /></b-button>
                          <b-button
                          :disabled="
                              !documents.uploaded.find(
                                (el) => el.attachment.id === doc.id
                              ) || ngoInfo.current_stage == 4
                            "
                            target="_blank"
                            variant="flat-primary"
                            class="btn-icon"
                            v-b-tooltip.hover.v-success.bottom
                            title="تعديل الملف"
                            @click="onClickEdit(doc.id)"
                            ><feather-icon icon="EditIcon"
                          /></b-button>
                          <b-button
                            @click="downloadFile({ep : `v2/establishment/download-document/${doc.form}`, name:'file'} )"
                            variant="flat-success"
                            class="btn-icon"
                            v-b-tooltip.hover.v-success.bottom
                            :disabled="doc.form == null  || ngoInfo.current_stage == 4"
                            title="تحميل النموذج"
                            ><feather-icon icon="DownloadIcon"
                          /></b-button>
                        </b-button-group>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
         
          <b-modal
            v-if="activeModalFile"
            size="lg"
            v-model="commentsModal"
            hide-backdrop
            footer-class="removed"
            :title="`رد الوزارة على ملف ${activeModalFile.filename}`"
          >
            <b-card-text class="p-1">
              <div v-html="modalComments"></div>
            </b-card-text>
          </b-modal>
        </div>
      </div>
    </div>
    <b-sidebar
      right
      width="700px"
      shadow
      bg-variant="white"
      backdrop
      id="doc-view"
    >
      <div class="h-100 p-1 text-center">
        <h4>{{ file ? file.name : "" }}</h4>
        <hr />
        <iframe
          :key="iframeSrc"
          class="w-100 rounded-lg border border-dark"
          style="height: 90%"
          :src="iframeSrc"
        ></iframe>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BFormFile,
  BInputGroup,
  BInputGroupAppend,
  BFormGroup,
  BButton,
  BRow,
  BCol,
  BListGroup,
  BListGroupItem,
  BSidebar,
  BLink,
  BButtonGroup,
  BModal,
  BCardText,
  BFormValidFeedback,
  BFormInvalidFeedback,
  VBToggle,
  VBTooltip,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
export default {
  directives: { "b-toggle": VBToggle, "b-tooltip": VBTooltip },
  components: {
    BFormFile,
    BInputGroup,
    BInputGroupAppend,
    BFormGroup,
    BButton,
    BRow,
    BCol,
    BListGroup,
    BListGroupItem,
    BSidebar,
    BLink,
    BButtonGroup,
    BModal,
    BCardText,
    BFormValidFeedback,
    BFormInvalidFeedback,
  },
  data() {
    return {
      file: null,
      files: [],
      docView: false,
      modalComments: "",
      activeModalFile: null,
      commentsModal: false,
      viewDoc: null,
    };
  },
  computed: {
    ...mapGetters("TempNgo/Documents", ["documents", "working", "loading"]),
    ...mapGetters("TempNgo", ["ngoInfo" , "founders"]),

    iframeSrc() {
      return this.viewDoc ? this.viewDoc : "";
    },
  },
  watch: {
    documents: {
      handler(newVal, oldVal) {
        if(this.ngoInfo &&  this.ngoInfo.current_stage == 2){
          var filesRequired = this.documents.required.filter(
            (e) => e.is_required === 1
          );
          var filesUploaded = this.documents.uploaded.filter(
            (e) => e.attachment.is_required === 1
          );
          console.log('filesRequired.length', filesRequired.length)
          console.log('filesUploaded.length', filesUploaded.length)
          if(this.documents && filesUploaded.length === filesRequired.length ){
            this.changeCurrentStage(3)
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("TempNgo/Documents", ["fetchDocuments", "uploadDocument" , "editDocument" , "downloadFile"]),
    ...mapActions("TempNgo", ["fetchNgoData" , "changeCurrentStage"]),
    fileInput(payload , n = null) {
      var val
      if (n) {
        val = this.documents.uploaded.filter((el) => el.attachment.id === payload.attachment_id)[n-1];

      } else {
        val = this.documents.uploaded.find((el) => el.attachment.id === payload.attachment_id);
      }
        if (val) {
          payload.id_edit = val.id
          this.editDocument(payload);
        }
        else{
          this.uploadDocument(payload);
        }
    },
    getFileStatus(id, n) {
      if (n) {
        var val = this.documents.uploaded.filter(
          (el) => el.attachment.id === id
        );
        if (val[n - 1]) {
          return val[n - 1].file_status === "pending"
            ? true
            : false
        } else return null;
      } else {
        var val = this.documents.uploaded.find((el) => el.attachment.id === id);
        if (val) {
          return val.file_status === "pending"
            ? true
            : false;
        } else return null;
      }
    },
    onClickEdit(id, n) {
      console.log('id' , id)
      if (n) {
        var val = this.documents.uploaded.filter(
          (el) => el.attachment.id === id
        );
        if (val[n - 1]) {
          val[n - 1].file_status = "denied"
        } 
      } else {
        var val = this.documents.uploaded.find((el) => el.attachment.id === id);
        if (val) {
          val.file_status = "denied"
        } 
      }
    },
    setCommentsModal(doc, n) {
      this.activeModalFile = doc;
      var pluckComment = "";
      if (n) {
        pluckComment = this.documents.uploaded.filter(
          (el) => el.attachment.id  === doc.id
        )[n - 1].comment;
      } else {
        pluckComment = this.documents.uploaded.find(
          (el) => el.attachment.id  === doc.id
        ).comment;
      }
      this.modalComments = pluckComment;
      this.commentsModal = true;
    },
    setViewDoc(doc, n) {
      var key = doc.id;
      var res = null;
      if (n) {
        res = this.documents.uploaded.filter((el) => el.attachment.id === key)[n-1];

      } else {
        res = this.documents.uploaded.find((el) => el.attachment.id === key);
      }
      if (res) this.viewDoc = res.source;
      return this.viewDoc
    },
    isCommentsDisabled(id, n) {
      var val = null;
      if (n) {
        val = this.documents.uploaded.filter((el) => el.attachment.id  === id)[
          n - 1
        ];
      } else {
        val = this.documents.uploaded.find((el) => el.attachment.id  === id);
      }
      if (val) {
        return val.comment ? false : true;
      } else return true;
    },
    isPending(id, n) {
      if (n) {
        var val = this.documents.uploaded.filter(
          (el) => el.attachment.id  === id
        );
        if (val[n - 1])
          return val[n - 1].file_status === "pending" ? true : false;
        else return false;
      } else {
        var val = this.documents.uploaded.find((el) => el.attachment.id  === id);
        if (val) return val.file_status === "pending" ? true : false;
        else return false;
      }
    },
    getFilePlaceholder(id, n) {
      if (n) {
        var val = this.documents.uploaded.filter(
          (el) => el.attachment.id  === id
        );
        if (val[n - 1]) {
          return val[n - 1].file_status === "pending"
            ? "تم رفع الملف"
            : "أعد رفع الملف"
        } else return "اختر ملفاً ...";
      } else {
        var val = this.documents.uploaded.find((el) => el.attachment.id === id);
        if (val) {
          return val.file_status === "pending"
            ? "تم رفع الملف"
            : "أعد رفع الملف"
        } else return "اختر ملفاً ...";
      }
    },
  },
  async created() {
    
    this.fetchDocuments();
  },
};
</script>

<style lang="scss">
.input-group:not(.bootstrap-touchspin):focus-within {
  box-shadow: none;
}
</style>
